@if (hydrated$ | async) {
  @if ((consent$ | async) === null) {
  
  <div
    class="fixed inset-x-0 bottom-0 z-[9999]"
    *transloco="let t; prefix: 'cookiesBaner'"
  >
    <div
      class="w-full border-t-4 border-[#f5b301] bg-white shadow-[0_-8px_24px_rgba(0,0,0,0.12)] min-h-[20vh] md:px-[5%] p-2"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-title"
      aria-describedby="cookie-description"
    >
  
      @if (!settingsOpen) {
        <div class="flex flex-col justify-center items-center gap-2 md:flex-row md:justify-between md:items-start md:gap-4">
          <div class="w-full px-3">
            <div class="text-lg font-semibold text-gray-900" id="cookie-title">
              {{ t('title') }}
            </div>
            <div class="mt-2 text-sm text-gray-600" id="cookie-description">
              {{ t('description')}} <span [routerLink]="[ContactsInfo.Cookie]"  class="text-orange-400 cursor-pointer" id="cookie-info-link">{{ t('information') }}</span>
            </div>
          </div>
  
          <div class="flex flex-col w-full px-3 gap-2 mt-2 md:mt-0 md:w-auto">
            <p-button (click)="accept()" styleClass="md:w-[200px] md:h-auto w-full h-[40px]">
              {{ t('accept') }}
            </p-button>
            <p-button (click)="reject()" styleClass="md:w-[200px] md:h-auto w-full h-[40px]">
              {{ t('reject') }}
            </p-button>
            <p-button (click)="openSettings()" styleClass="md:w-[200px] md:h-auto w-full h-[40px]">
              {{ t('settings') }}
            </p-button>
          </div>
        </div>
      }
      @if (settingsOpen) {
        <div>
          <p-tabs class="custom-tabs" value="0">
            <p-tablist class="!bg-white">
              <p-tab value="0" class="!bg-white" >
                {{ t('essential') }}
              </p-tab>
              <p-tab value="1" class="!bg-white">
                {{ t('functional') }}
              </p-tab>
            </p-tablist>
            <p-tabpanels class="!bg-white">
  
              <!-- Essential -->
              <p-tabpanel value="0" class="!bg-white">
                <div class="flex items-center justify-between bg-[#fff0ca] rounded-xl p-2 mt-2">
                  <div>
                    <div class="font-medium text-sm">
                      {{ t('essentialCookies') }}
                    </div>
                    <div class="text-xs text-gray-500">
                      {{ t('essentialDescription') }}
                    </div>
                  </div>
                  <div class="flex items-center min-w-12">
                    <p-toggleswitch
                      styleClass="cookie-toggle"
                      [ngModel]="true"
                      [disabled]="true"
                      aria-label="Essential cookies always enabled"
                    >
                    </p-toggleswitch>
                  </div>
                </div>
              </p-tabpanel>
  
              <!-- Functional -->
              <p-tabpanel value="1">
                <div class="flex items-center justify-between bg-[#fff0ca] rounded-xl p-2 mt-2">
                  <div>
                    <div class="font-medium text-sm">
                      {{ t('functionalCookies') }}
                    </div>
                    <div class="text-xs text-gray-500">
                      {{ t('functionalDescription') }}
                    </div>
                  </div> 
                  <div class="flex items-center min-w-12">
                    <p-toggleswitch [(ngModel)]="functionalTemp" aria-label="Enable functional cookies"></p-toggleswitch>
                  </div>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
  
          <div class="flex justify-center flex-col mt-2 gap-2 md:flex-row md:justify-end md:mt-4">
  
            <p-button
              (click)="closeSettings()" styleClass="w-full h-[40px] md:h-auto">
                {{ t('cancel') }}
            </p-button>
            <p-button
              (click)="saveSettings()" styleClass="w-full h-[40px] md:h-auto">
                {{ t('save') }}
            </p-button>
          </div>
        </div>
      }
    </div>
  </div>
  }
}